import React from 'react';
import PropTypes from 'prop-types';
import LineTitleGray from '../atoms/titles/LineTitleGray';

const RoomDetail = ({ room, roomType }) => {
  const { name, feature } = roomType;

  const {
    capacity,
    area,
    bed,
    equipment,
  } = room;

  return (
    <React.Fragment>
      <LineTitleGray>部屋タイプ {name}</LineTitleGray>
      <div className="planDetailTextBody">
        <div className="texts">
          <div className="text">{feature}</div>
          <div className="text textBold">
            【定員】 {capacity && capacity.min}〜{capacity && capacity.max}名
            <br />【広さ】 {area}
            <br />【ベッド】 {bed}
          </div>
        </div>
        <div className="table">
          <div className="planDetailTable">
            <div className="planDetailTableHeader">宿泊条件</div>
            <div className="planDetailTableBody">
              <div className="planDetailTableBodyItem">
                <div className="name">常備品(無料)</div>
                <div className="content">{equipment && equipment.RegularFree}</div>
              </div>
              <div className="planDetailTableBodyItem">
                <div className="name">常備品(有料)</div>
                <div className="content">{equipment && equipment.RegularPaid}</div>
              </div>
              <div className="planDetailTableBodyItem">
                <div className="name">貸出し品(無料)</div>
                <div className="content">{equipment && equipment.RentalFree}</div>
              </div>
              <div className="planDetailTableBodyItem">
                <div className="name">貸出し品(有料)</div>
                <div className="content">{equipment && equipment.RentalPaid}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

};

RoomDetail.propTypes = {
  room: PropTypes.object.isRequired,
  roomType: PropTypes.object.isRequired,
};

export default RoomDetail;
